import { Tag, Typography } from '@neo4j-ndl/react';
import { ExclamationTriangleIconOutline } from '@neo4j-ndl/react/icons';
import type { FleetManagementTypes } from '@nx/state';

import { DEPLOYMENT_STATUS } from '../../../../../../packages/state/src/slices/fleet-management/api-types';

export type UnmonitoredServersBadgeProps = {
  viewType: 'table' | 'list' | 'graph';
};

export const UnmonitoredServersBadge = ({ viewType }: UnmonitoredServersBadgeProps) => {
  return (
    <Tag type="destructive" size="medium" className="flex w-fit items-center gap-1">
      {viewType !== 'table' && <ExclamationTriangleIconOutline className="h-4 w-4" />}
      <Typography variant="body-medium">
        Deployment has unmonitored servers. Consider installing fleet management plugin on every server.
      </Typography>
    </Tag>
  );
};

export const hasUnmonitoredServers = (dbms: FleetManagementTypes.DbmsDetails) =>
  dbms.servers.some((server) => server.status === DEPLOYMENT_STATUS.UNMONITORED);
